exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav{padding-top:10em;background-color:#2a3a4a}ul{list-style-type:none;padding:0}a{color:#000}li{margin-left:1em;margin-right:1em;margin-bottom:1em}.link_button{-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;border:1px solid #20538d;text-shadow:0 -1px 0 rgba(0,0,0,.4);background:#fff;padding:8px 12px;text-decoration:none;text-align:center}@media (max-width:678px){nav{padding-top:2em!important;padding-bottom:1em!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9f28ff9e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Menu.vue
// module id = 346
// module chunks = 0